module.exports = __webpack_public_path__ + "static/media/Blizzard-Logo.3ffd1528.jpg";